/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Grid,
    MenuItem,
    Paper,
    CardContent,
    Typography,
    Box,
    Fade,
    FormControlLabel,
    Checkbox,
    Button
} from '@mui/material';
import {
    Public,
    Add,
    Edit as EditIcon,
    Save as SaveIcon,
    Cancel as CancelIcon
} from '@mui/icons-material';
import { useProvince } from 'hooks/api/terminology/province/useProvince';
import { AnimatedButton, StyledCard, StyledTextField, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';

const AddEditProvince = ({ editingProvince, onProvinceSubmitted }) => {
    const [formData, setFormData] = useState({
        name: '',
        id: '',
        code: '',
        localName: '',
        description: '',
        isActive: true,
        longitude: 0,
        latitude: 0
    });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const { createProvince, updateProvince } = useProvince();

    // Initialize form data when editing
    useEffect(() => {
        if (editingProvince) {
            setFormData({
                name: editingProvince.name || '',
                id: editingProvince.id || '',
                code: editingProvince.code || '',
                localName: editingProvince.localName || '',
                description: editingProvince.description || '',
                isActive: editingProvince.isActive !== undefined ? editingProvince.isActive : true,
                longitude: editingProvince.longitude || 0,
                latitude: editingProvince.latitude || 0
            });
        } else {
            // Reset form for new province
            setFormData({
                name: '',
                id: '',
                code: '',
                localName: '',
                description: '',
                isActive: true,
                longitude: 0,
                latitude: 0
            });
        }
        setErrors({});
    }, [editingProvince]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = 'Province name is required';
        }
        
        if (!editingProvince && !formData.id.trim()) {
            newErrors.id = 'Province ID is required';
        }

        if (!formData.code.trim()) {
            newErrors.code = 'Province code is required';
        }

        // Validate longitude range
        if (formData.longitude < -180 || formData.longitude > 180) {
            newErrors.longitude = 'Longitude must be between -180 and 180';
        }

        // Validate latitude range
        if (formData.latitude < -90 || formData.latitude > 90) {
            newErrors.latitude = 'Latitude must be between -90 and 90';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please fill in all required fields correctly.'
            });
            return;
        }

        setLoading(true);
        try {
            // Prepare data for submission
            const submitData = {
                ...formData,
                longitude: Number(formData.longitude),
                latitude: Number(formData.latitude)
            };

            if (editingProvince) {
                await updateProvince(editingProvince.id, submitData);
                Swal.fire({
                    icon: 'success',
                    title: 'Province Updated',
                    text: 'The province has been successfully updated.',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                await createProvince(submitData);
                Swal.fire({
                    icon: 'success',
                    title: 'Province Created',
                    text: 'The province has been successfully created.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            onProvinceSubmitted();
        } catch (error) {
            logger.error('Error saving province:', error);
            
            let errorMessage = `Failed to ${editingProvince ? 'update' : 'create'} the province. Please try again.`;
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        onProvinceSubmitted();
    };

    return (
        <Fade in timeout={1000}>
            <StyledCard elevation={0}>
                <CardContent>
                    <Typography
                        variant="h5"
                        gutterBottom
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            color: globalColor,
                            fontWeight: 'bold',
                            mb: 4
                        }}
                    >
                        <Public /> {editingProvince ? 'Edit Province' : 'Add New Province'}
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="name"
                                label="Province Name *"
                                value={formData.name}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.name}
                                helperText={errors.name}
                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="id"
                                label="Province ID *"
                                value={formData.id}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.id}
                                helperText={errors.id}
                                disabled={loading || editingProvince} // Disable ID field when editing
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="code"
                                label="Province Code *"
                                value={formData.code}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.code}
                                helperText={errors.code}
                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="localName"
                                label="Local Name"
                                value={formData.localName}
                                onChange={handleChange}
                                variant="outlined"
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="longitude"
                                label="Longitude"
                                type="number"
                                value={formData.longitude}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.longitude}
                                helperText={errors.longitude || 'Value between -180 and 180'}
                                disabled={loading}
                                inputProps={{
                                    min: -180,
                                    max: 180,
                                    step: 0.000001
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                fullWidth
                                name="latitude"
                                label="Latitude"
                                type="number"
                                value={formData.latitude}
                                onChange={handleChange}
                                variant="outlined"
                                error={!!errors.latitude}
                                helperText={errors.latitude || 'Value between -90 and 90'}
                                disabled={loading}
                                inputProps={{
                                    min: -90,
                                    max: 90,
                                    step: 0.000001
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <StyledTextField
                                fullWidth
                                name="description"
                                label="Description"
                                value={formData.description}
                                onChange={handleChange}
                                variant="outlined"
                                multiline
                                rows={3}
                                disabled={loading}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                        name="isActive"
                                        disabled={loading}
                                        sx={{
                                            color: globalColor,
                                            '&.Mui-checked': {
                                                color: globalColor
                                            }
                                        }}
                                    />
                                }
                                label="Active"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                    sx={{
                                        borderColor: globalColor,
                                        color: globalColor,
                                        '&:hover': {
                                            borderColor: globalColor,
                                            backgroundColor: `${globalColor}10`
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <AnimatedButton
                                    variant="contained"
                                    startIcon={editingProvince ? <SaveIcon /> : <Add />}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    size="large"
                                >
                                    {loading ? 'Saving...' : (editingProvince ? 'Update Province' : 'Add Province')}
                                </AnimatedButton>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>
        </Fade>
    );
};

export default AddEditProvince;